import { Component, ComponentRef, Injector, Input, NgZone, ViewContainerRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { BaseComponentWithDialog } from "../../../admin-panel/base-admin-panel/base-component-with-dialog";

@Component({
    selector: 'app-devices-list',
    templateUrl: './devices-list.component.html',
    styleUrls: ['./devices-list.component.css'],
    standalone: false
})
export class DevicesListComponent extends BaseComponentWithDialog implements OnInit,OnDestroy {
  @Input() trackingMode: boolean;
  @Input() hiddenMode: boolean = false;
  @Input() rootID: string = "objects_top";
  @Input() groupRootID: string = "devicegroups";
  @Input() listRootID: string = "devicelist";
  @Input() pagerClass: string = "objectspager";

  constructor(protected injector: Injector) {
    super(injector);
  }
  ngOnInit() {
  }
  ngOnDestroy() {
  }
}
